<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8LbzFj/media/FC-9798889100553.jpg?1743119314665" alt="This image is the cover for the book Guardian Guerrillas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Guardian Guerrillas
      </h1>
      <p class="bookDescription body article font2">
        <p>This is the fascinating story of Frank James, Jesse James older brother, as a bushwhacker in Quantrill’s Partisan Rangers during the Civil War. The actions of this brash, Shakespeare quoting young man represents the best and worst of guerrilla warfare in those turbulent and violent times.</p><p><br/></p><p>After fighting as a Confederate soldier at Wilson’s Creek, captured and paroled, he returned home as a cocky nineteen-year-old barely staying out of jail. He joins Quantrill’s bushwhackers with escapades that are full of daring and bravery, sometimes cruelty, but also with humour.</p><p><br/></p><p>We follow him through the many skirmishes and battles including the raids on Lawrence Kansas and Centralia Missouri and the critical events that precipitated them, the women’s prison collapse where several bushwhacker relatives were killed or injured and the infamous “General Order Number 11” that forcibly drove out all residents of an area over 2,200 square miles, twice the size of Rhode Island.</p><p><br/></p><p>The characters in this work include soldiers, generals, politicians, crooks, thieves, farmers, bankers, lovers, wives, and sisters that suffered or caused suffering in this oft untold American history and their post bellum lives that were fraught with danger, excitement, success for some, failure for many, with ironic, karmic twists.</p><p><br/></p><p>What drove these young men to become Jayhawkers and Bushwhackers? Were they blood thirsty cutthroats or <em>Guardian Guerrillas?</em></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Drennen
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Tom Drennen is a long-time student of the American Civil War, particularly the guerrilla warfare in his home state of Missouri. After retiring from a successful career as an engineer at Sikorsky Aircraft, he turned his attention to researching what forces drove young men in the 1860s to become Jayhawkers and Bushwhackers. He is a founding member of the Shoreline Civil War Discussion Group in Connecticut. Tom is also a life-long St. Louis Cardinals fan. Go Redbirds!</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?459c0a54